import { render } from "./App.vue?vue&type=template&id=79d62f9d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=79d62f9d&lang=css"

import exportComponent from "/Users/Learning/Documents/Workspace/VSCode/HTML/_GitHub/shenwedding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__